import React, { FunctionComponent } from 'react';
import styles from '../../../styles/ArticleHeading.module.scss';
import { SocialIcons } from './SocialIcons';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import { ImageModel } from '../../../services/content/image/models/ImageModel';
import { getMainImageFromMainMedia } from '../../../services/content/mainMedia/MainMedia';
import { parsePublishedAt } from '../../../services/helpers/GeneralHelper';
import { CategoryText } from '../../Partials/Category/CategoryText';
import { hasAuthors } from '../../../constants/GlobalHelpers';
import { PhotoBy } from './PhotoBy';
import { mergeAuthorsWithCustomAuthor } from '../../../services/content/author/Author';
import MainMedia from './MainMedia';
import { AdsConfig } from './models/AdsConfig';

type Props = {
    article: ArticleModel;
    className?: string;
    adsConfig: AdsConfig;
};

export const ArticleHeading: FunctionComponent<Props> = ({ article, className, adsConfig }) => {
    const image: ImageModel | null = getMainImageFromMainMedia(article.mainMedia);

    return (
        <div className={`flex-column mb-1 font-lato-400, ${className ? className : ''}`}>
            <MainMedia adsConfig={adsConfig} mainMedia={article.mainMedia} imgAlt={article.title} />
            <div className='container-fluid'>
                <div className='row'>
                    <PhotoBy
                        className={`${styles.photoBy} ${styles.dynamicText} col-4`}
                        publishedAt={article.publishedAt}
                        image={image}
                    />
                    <CategoryText className='col-4 text-center' categorySlug={article.category?.seo?.slug}>
                        {article.category?.title.toUpperCase()}
                    </CategoryText>
                    <div className={`${styles.dynamicText} col-4 d-flex d-md-none`}>
                        <div className='w-100 text-end'>{parsePublishedAt(article.publishedAt)}</div>
                    </div>
                    <div className='col-4 d-md-flex d-none'>
                        <div className='w-100 text-end'>
                            <SocialIcons article={article} />
                        </div>
                    </div>
                </div>
                <div
                    className={`${styles.author} font-playfair-700 mb-3 d-flex flex-row justify-content-center align-items-center`}>
                    {hasAuthors(article.authors) ? <div className={`author-label me-1`}>Автор</div> : null}
                    {hasAuthors(article.authors)
                        ? `${mergeAuthorsWithCustomAuthor(article.authors, article.customAuthor)}`
                        : ''}
                </div>
                <div className='mb-4'>
                    <SocialIcons article={article} className='d-md-none d-flex' />
                </div>
                <h2 className={`${styles.title} text-center font-playfair-700`}>{article.title}</h2>
            </div>
        </div>
    );
};
